<template>
  <div class="mt-8 w-full h-full bg-white">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AttributesView',
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('InventoryModule/Attributes/fetchAllAttributesGroups');
      await this.$store.dispatch('InventoryModule/Attributes/fetchAllAttributes');
    } catch (e) {
      //
    }
  },
};
</script>

<style scoped>

</style>
